import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CustomToast from '../../../components/Toast';
import {
  useCheckImageExistMutation,
  useUploadImagesMutation 
} from '../../../features/authentication/teacherDocumentApiSlice';

const ImageUploadSection = ({ maxFiles = 4, onSuccess }) => {
  const [uploadFiles, setUploadFiles] = useState([null]);
  const [uploadImages, {isLoading : isUploading}] = useUploadImagesMutation();
  const [checkImageExist] = useCheckImageExistMutation();

  const allowedExtensions = ['jpg', 'png', 'gif'];
  const maxSize = 1 * 1024 * 1024;

  const handleFileChange = async (index, file) => {
    if (!file) return;
    const extension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      CustomToast(
        `Invalid file type: ${file.name}\nOnly JPG, PNG, GIF allowed.`,
        'warning'
      );
      return;
    }

    if (file.size > maxSize) {
      CustomToast(
        `File too large: ${file.name}\nMaximum size is 1MB.`,
        'warning'
      );
      return;
    }

    const isDuplicate = uploadFiles.some(
      (f, i) =>
        f &&
        i !== index &&
        f.name === file.name &&
        f.size === file.size &&
        f.lastModified === file.lastModified
    );

    if (isDuplicate) {
      CustomToast('This image is already selected.', 'warning');
      return;
    }

    const response = await checkImageExist(encodeURIComponent(file.name));
    if(response.error)
      return;

    const updated = [...uploadFiles];
    updated[index] = file;
    if (index === uploadFiles.length - 1 && uploadFiles.length < maxFiles) {
      updated.push(null);
    }
    setUploadFiles(updated);
  };

  const handleUploadAll = () => {
    const validFiles = uploadFiles.filter(file => file !== null);
  
    if (validFiles.length === 0) {
      CustomToast('Please select at least one file.', 'warning');
      return;
    }
    uploadImagesAsync();
  };

  const uploadImagesAsync = async () => {
    const formData = new FormData();
    uploadFiles.forEach(file => {
      if (file) {
        formData.append('files', file);
      }
    });
    var response = await uploadImages(formData);
    if(!response.error){
      CustomToast('Images uploaded successfully.', 'success');
      setUploadFiles([null]);
      onSuccess();
    }
  };

  const handleUploadClose = (index) => {
    let updated = [...uploadFiles];
    updated.splice(index, 1);
    updated = updated.filter(f => f !== null);
    if (updated.length < maxFiles) {
      updated.push(null);
    }
    setUploadFiles(updated);
  };
  
  
  return (
    <>
      <div className="upload-section  align-items-center">
        <div className="upload-row">
          {uploadFiles.map((file, index) => (
            <div key={index}   className='upload-card'>
              {file && (
                <button
                  type="button"
                  className="upload-card-close"
                  onClick={() => handleUploadClose(index)}
                >✕</button>
              )}
              <label className="upload-label">
                {file ? (
                  <>
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      className="preview-image p-2"
                    />
                    <div className="file-name text-break"  title={file.name}>{file.name}</div>
                  </>
                ) : (
                  <>
                    <div className="plus-icon">+</div>
                    <div>Upload</div>
                  </>
                )}
                <input
                  type="file"
                  hidden
                  accept=".jpg,.png,.gif"
                  onChange={(e) =>{
                    handleFileChange(index, e.target.files[0]);
                    e.target.value ='';
                  }
                  }
                />
              </label>
            </div>
          ))}
        </div>
        {uploadFiles[0] &&
      <div className="upload-action">
        <button
          className="btn btn-width btn-castleRed"
          onClick={()=> handleUploadAll()}
          disabled={isUploading}
        >
          Upload All
        </button>
      </div>
        }
      </div>
      <p className='text-danger mb-4'>You can upload image files into your Personal Image Folder on the Castle Learning Online server for use with your questions. The files must be at most 1MB in size and must be &quot;png&quot;, &quot;gif&quot; or &quot;jpg&quot; files.</p>
    </>
  );
};

ImageUploadSection.propTypes = {
  maxFiles: PropTypes.number,
  onSuccess: PropTypes.func
};
  
export default ImageUploadSection;
